import {Column, Entity, ManyToOne} from "typeorm";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import {BankCategory} from "@/modules/finances/enums";
import {Season} from "@/modules/season/entity";

@Entity({orderBy: {id: 'DESC'}})
export class BankLog extends BaseEntity {
  @ManyToOne(() => Season)
  season: Season;

  @Column({type: "varchar"})
  category: BankCategory;

  @Column({type: "varchar"})
  label?: string;

  @Column({type: "integer"})
  amount: number;

  @Column({type: "date"})
  createdAt: Date;
}